import React from 'react'
import BaseButton from 'shared/components/button/components/base-button'
import { ButtonType } from 'shared/components/button/types/button-interface'

const SecondaryButton = (props: ButtonType) => (
  <BaseButton
    color={'text-text-primary'}
    hoverColor={'hover:text-background-secondary'}
    backgroundColor={'bg-transparent'}
    hoverBackgroundColor={'hover:bg-text-primary'}
    borderColor={'border-text-primary'}
    loaderType={'dark'}
    {...props}
  />
)
export default SecondaryButton
